<template>
  <div id="app">
    <header id="app-header">
      <b-navbar toggleable="md" type="dark" variant="primary" fixed="top">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand>
          <h1>
            <img id="logo" alt="ZikMate" src="./assets/logo_menu.png">
          </h1>
        </b-navbar-brand>
        <b-collapse is-nav id="nav_collapse">
          <b-nav pills is-nav-bar>
            <b-nav-item to="/profile">Accueil</b-nav-item>
            <b-nav-item
              v-if="token"
              to="/search"
              variant="primary"
            >Trouvez des musiciens près de vous</b-nav-item>
            <b-nav-item v-if="token" to="/chat" variant="primary">Chat</b-nav-item>
            <b-nav-item to="/about" variant="primary">A propos</b-nav-item>
          </b-nav>
          <div v-if="token" id="search" class="input-group ml-auto">
            <vue-autosuggest
              id="searchbar"
              :suggestions="suggestions"
              :inputProps="inputProps"
              :sectionConfigs="sectionConfigs"
              :renderSuggestion="renderSuggestion"
              :getSuggestionValue="getSuggestionValue"
            />
            <span class="input-group-append">
              <div class="input-group-text">
                <i class="fa fa-search"></i>
              </div>
            </span>
          </div>
          <b-navbar-nav class="ml-auto" v-if="token">
            <router-link to="/profile">
              <b-img
                class="profile_picture_header"
                rounded="circle"
                height="50"
                width="50"
                alt="Photo de profil"
                :src="user.picture"
              />
            </router-link>
            <b-nav-item-dropdown :text="user.username" right>
              <b-dropdown-item to="/profile">
                <i class="fa fa-user-circle fa-lg fa-fw"></i> Mon profil
              </b-dropdown-item>
              <b-dropdown-item to="/friends">
                <i class="fa fa-users fa-lg fa-fw"></i> Mes amis
              </b-dropdown-item>
              <b-dropdown-item to="/settings">
                <i class="fa fa-cog fa-lg fa-fw"></i> Paramètres
              </b-dropdown-item>
              <b-dropdown-item v-if="token && user.role === 'admin'" to="/admin">
                <i class="fa fa-cog fa-lg fa-fw"></i> Administration
              </b-dropdown-item>
              <b-dropdown-item @click="logout">
                <i class="fa fa-sign-out fa-lg fa-fw"></i> Déconnexion
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <router-view :key="$route.fullPath"/>
    <b-modal
      :visible="alert.show"
      @hide="clearAlert"
      :title="alert.title"
      lazy
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
    >
      <div v-html="alert.message"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { router } from "./helpers";

export default {
  name: "App",
  data() {
    return {
      results: [],
      timeout: null,
      debounceMilliseconds: 50,
      inputProps: {
        id: "autosuggest__input",
        onInputChange: this.fetchResults,
        placeholder: "Recherchez un musicien...",
        class: "form-control",
        name: "searchbar"
      },
      suggestions: [],
      sectionConfigs: {
        users: {
          label: "Utilisateurs",
          onSelected: function(selected) {
            router.push({
              name: "UserProfile",
              params: { userId: selected.item.id }
            });
          }
        }
      }
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      token: state => state.account.token,
      user: state => state.account.user,
      foundUsers: state => state.users.all
    })
  },
  watch: {
    foundUsers: function(newVal) {
      if (newVal.loaded) {
        this.suggestions = [{ name: "users", data: newVal.users.data }];
      }
    }
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      logout: "account/logout",
      getAllUsers: "users/getAll"
    }),
    fetchResults(val) {
      if (!val) {
        this.suggestions = [];
        return;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getAllUsers({
          userId: this.user.id,
          search: val,
          sort: "username"
        });
      }, this.debounceMilliseconds);
    },
    renderSuggestion(suggestion) {
      return (
        <a
          href="#"
          title={
            suggestion.item.username +
            " (" +
            (suggestion.item.firstname
              ? suggestion.item.firstname + " "
              : null) +
            (suggestion.item.lastname ? suggestion.item.lastname + " " : null) +
            suggestion.item.email +
            ")"
          }
        >
          <img
            src={suggestion.item.picture}
            alt="Photo de profil"
            width="30"
            height="30"
            class="rounded-circle"
          />
          {suggestion.item.username} (
          {suggestion.item.firstname ? `${suggestion.item.firstname} ` : null}
          {suggestion.item.lastname ? `${suggestion.item.lastname} ` : null}
          {suggestion.item.email})
        </a>
      );
    },
    getSuggestionValue() {
      return "";
    }
  }
};
</script>

<style>
@import url("../node_modules/font-awesome/css/font-awesome.min.css");
@import url("https://fonts.googleapis.com/css?family=Amaranth");

html,
body {
  height: 100%;
}

h1 {
  margin: 0;
}

h2 {
  color: #2aab2a;
  font-family: "Amaranth", sans-serif;
  font-size: 2.5rem;
  text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
}

@media screen and (max-width: 768px) {
  h2 {
    font-size: 2rem;
  }
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

#app-header {
  text-align: center;
}

section {
  background: url(assets/background.jpg) no-repeat center 78px fixed;
  background-size: cover;
  min-height: 100%;
  padding-top: 78px;
}

.section-title {
  padding: 1rem 0 2rem;
}

@media screen and (max-width: 768px) {
  .section-title {
    padding: 0.5rem 0 1rem;
  }
}

.section-content {
  height: 100%;
}

#logo {
  max-width: 100%;
  height: auto;
  width: auto\9; /* ie8 */
}

.profile_picture_header {
  border: 1px solid #fff;
}

.card {
  background-color: #e6ffe6;
  border-color: #32cd32;
  text-align: center;
}
.card-header {
  background-color: #32cd32;
  border-color: #32cd32;
  font-weight: bold;
}
.navbar-nav .nav-item {
  margin: 0.5rem;
}
.navbar-nav .nav-link,
.nav-pills .nav-link {
  color: #fff !important;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem !important;
}
.navbar-nav .nav-link:hover,
.navbar-nav .nav-link.active,
.nav-pills .nav-link.active {
  color: #2cb62c !important;
  background-color: #fff;
}
.dropdown-item,
.dropdown-item:hover,
.dropdown-item:focus {
  color: #2cb62c;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #32cd32 !important;
  color: #fff;
}
.bg-primary {
  background-color: #32cd32 !important;
}
.btn {
  margin-bottom: 1em;
}
.input-group .btn {
  margin: 0;
}
.btn-primary {
  background-color: #32cd32 !important;
  border-color: #32cd32 !important;
  font-weight: bold;
}
.btn-primary:hover {
  background-color: #2cb62c;
  border-color: #2cb62c;
}
.btn-danger {
  font-weight: bold;
}
.btn-social {
  color: #fff !important;
  font-weight: bold;
  text-align: center;
}
.form-group {
  margin-bottom: 1em;
  text-align: left;
}
.form-control,
.form-control.custom-select option,
.form-control.custom-select.defined {
  border-color: #32cd32 !important;
  color: #2cb62c !important;
}
.form-control::placeholder,
.form-control.custom-select {
  color: #bbb !important;
}
.form-control[readonly] {
  background-color: #fff;
}
.input-group-text {
  border-color: #32cd32;
  background-color: #32cd32;
}
.input-group-text i {
  color: #fff;
  font-weight: bold;
}
.loader {
  color: #32cd32;
  margin-left: 0.5em;
}
.modal-title {
  color: #fff;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}
.modal-header {
  background-color: #32cd32;
}
.modal-header .close {
  color: #fff;
  opacity: 1;
  margin: 0;
  padding: 0;
}
.modal-content {
  border-color: #32cd32;
}
.modal-footer .btn {
  margin: 0 auto;
}
i.fa-mars {
  color: #0084ff;
  font-weight: bold;
}
i.fa-venus {
  color: #ff00b3;
  font-weight: bold;
}
.dg-btn--ok {
  border-color: #32cd32;
  color: #32cd32;
}
.dg-btn--cancel {
  background-color: #32cd32;
}
.dg-btn-loader .dg-circle {
  background-color: #32cd32;
}
#search {
  width: auto;
}
#search .form-control {
  border: none !important;
  border-radius: 0.25rem 0 0 0.25rem !important;
  min-width: 266px;
}
#search .input-group-append {
  max-height: calc(2.25rem + 2px);
}
#search .input-group-text {
  border: none;
  background-color: #fff;
}
#search .input-group-text i {
  color: #32cd32;
}
#search .autosuggest__results {
  position: absolute;
  z-index: 100;
  background-color: #fff;
  max-height: 400px;
  min-width: 266px;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;
  margin: 1px 0;
  line-height: 0;
  border: 1px solid #32cd32;
  border-radius: 0.25rem;
}
#search .autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
#search .autosuggest__results ul li a {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 287px;
  overflow: hidden;
  color: #2aab2a;
  text-decoration: none;
  font-weight: bold;
}
#search .autosuggest__results ul li a img {
  margin-right: 0.5rem;
}
#search .autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
#search ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}
#search .autosuggest__results .autosuggest__results_title {
  color: #2aab2a;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 0.5rem;
  text-align: left;
}
#search .autosuggest__results .autosuggest__results_item:active,
#search .autosuggest__results .autosuggest__results_item:hover,
#search .autosuggest__results .autosuggest__results_item:focus,
#search
  .autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #e6ffe6;
}
</style>
